
export const fetchSessionLogsApi = (BeURL, setSessionLogs, currentPage, rowsPerPage,setTotlaSessionLogs,setTotalPage ) => {
    fetch(`${BeURL}/fetch-session-logs`,{
        method : 'POST',
        headers : {
            'Content-Type' : 'application/json'
        },
        credentials : 'include',
        body:  JSON.stringify({ pages: currentPage,  sessionLogsPerPage: rowsPerPage })
    })
    .then(res => res.json())
    .then(data => {
        if(data.success === true){
            setSessionLogs(data.sessionLogs)
            setTotlaSessionLogs(data.totalLogs)
            setTotalPage(data.totalPages)
        }
        else{
            alert(data.message)
        }
    })
    .catch(err => {
        console.error('Error fetching session logs:', err);
    })
}
